// Import/export auth modules

import auth from "./app/library/auth/plugin";
export default auth;
